﻿import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import Tooltip from '@mui/material/Tooltip';

function PoliciesSearchBar({ ...props }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end', margin: '0 1em' }}>
      <LibraryBooksIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
      <Tooltip title="What does PolicyID start with?">
        <TextField
          id="input-with-sx"
          label="Search for PolicyID"
          variant="standard"
          onBlur={(event) => {
            props.setSearchText(event.target.value);
          }}
        />
      </Tooltip>
    </Box>
  );
}

export { PoliciesSearchBar };
